function ConfirmDialog({ onConfirm, onCancel }) {
  return (
    <div className="overlay">
      <div className="overlay-content">
        <h2>Confirm Reshuffle</h2>
        <p>Are you sure you want to reshuffle? This will reset the deck and clear your current game progress.</p>
        <div className="confirm-buttons">
          <button className="confirm-yes" onClick={onConfirm}>
            ✅ Yes, Reshuffle
          </button>
          <button className="confirm-no" onClick={onCancel}>
            ❌ No, Keep Playing
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog; 